module.exports = __webpack_public_path__ + "static/media/vinsmoke-reiju.1ac24a4d.png";